import EventSource from '../EventSource.js';

class Alerter {
  constructor() {
    this.alertEvents = new EventSource();
    this.dismissEvents = new EventSource();
    this.nextId = 1;
  }

  onAlert(callback) {
    return this.alertEvents.subscribe(callback);
  }

  onDismiss(callback) {
    return this.dismissEvents.subscribe(callback);
  }

  alert(alert) {
    let event = {
      id: this.nextId++
    };
    if (alert instanceof Object) {
      event = {...alert, ...event};
    }
    else {
      event.message = alert;
      event.type = 'info';
    }

    this.alertEvents.publish(event);

    return event.id;
  }

  dismiss(id) {
    this.dismissEvents.publish({id});
  }
}

const instance = new Alerter();

export {
  instance as default,
  Alerter
};